import React, { useCallback } from 'react';
import {
  RouteProps,
} from 'react-router-dom';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import { MdChevronLeft } from 'react-icons/all';
import { useTheme } from '../contexts/ThemeContext';

type HeaderProps = {
  backHandler?: any,
  screen?: string,
  bottomPadding?: string,
  topPadding?: string,
  borderRadius?: string
} & RouteProps

const Root = styled.button`
  position: fixed;
  width: 45px;
  height: 45px;
  left: 15px;
  margin: 0;
  padding: 0;
  border: 0;
  text-decoration: none;
  color: white;
  background-color: ${(props) => props.color};
  opacity: .9;
  text-align: center;
  cursor: pointer;
  outline: none;
  font-size: 45px;
  font-family: Monospaced, sans-serif;
  &:hover {
    background-color: ${(props) => props.color};
    opacity: .6;
  }
  &:active {
    background-color: ${(props) => props.color};
    opacity: .5;
    outline: none;
  }
  &:focus {
    background-color: ${(props) => props.color};
    opacity: .4;
    outline: none;
  }
`;

const BackButton = ({ backHandler, screen, bottomPadding = '15px', topPadding, borderRadius = '45px' }:HeaderProps) => {
  const history = useHistory();
  const { theme } = useTheme();

  const handleBack = useCallback(() => {
    if (screen) {
      history.push(screen);
      return;
    }

    if (backHandler && typeof backHandler === 'function') {
      backHandler();
    }
  }, [backHandler]);

  const positionStyle = topPadding
    ? { top: topPadding, borderRadius }
    : { bottom: bottomPadding, borderRadius };

  return (
    <Root color={theme.buttonColor} onClick={handleBack} style={positionStyle}>
      <MdChevronLeft />
    </Root>
  );
};

export default BackButton;
